import React, { createContext, useContext } from "react";
import fr from "@/i18n/fr";
import en from "@/i18n/en";
import es from "@/i18n/es";
import { join } from "@/i18n/join";

export const DICTS = {
  fr: { ...fr, join: join.fr },
  en: { ...en, join: join.en },
  es: { ...es, join: join.es },
};
export const LANGS = ["fr", "en", "es"];
export const LANG_LABELS = { fr: "Français", en: "English", es: "Español" };

const I18nContext = createContext({ lang: "fr", t: (k) => k, dict: DICTS.fr });

export function detectLang() {
  const stored = typeof window !== "undefined" ? window.localStorage.getItem("cs_lang") : null;
  if (stored && LANGS.includes(stored)) return stored;
  const nav = typeof navigator !== "undefined" ? (navigator.language || "fr").slice(0, 2).toLowerCase() : "fr";
  return LANGS.includes(nav) ? nav : "fr";
}

function lookup(dict, path) {
  return path.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), dict);
}

export function I18nProvider({ lang, children }) {
  const dict = DICTS[lang] || DICTS.fr;
  const t = (path, fallback) => {
    const value = lookup(dict, path);
    if (value === undefined) return lookup(DICTS.fr, path) ?? fallback ?? path;
    return value;
  };
  return <I18nContext.Provider value={{ lang, t, dict }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export function useLangPath() {
  const { lang } = useI18n();
  return (path = "") => `/${lang}${path}`;
}
